<template>
  <div id="users" class="users">
    <div class="users-head">
      <div class="left">Active users</div>
      <div class="right" @click="()=>{isAddUser = true}">+ Add User</div>
    </div>
    <div>
      <el-table :data="userList" style="width: 100%">
        <el-table-column prop="customerRole" label="ROLE" :formatter="formatter" />
        <el-table-column prop="email" label="EMAIL" />
        <el-table-column prop="customerRole" label="PERMISSIONS" :formatter="formatterText" />
        <el-table-column prop="enabledMark" label="STATUS">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.enabledMark == 1"
              type="success"
              size="mini"
              disable-transitions
            >Active</el-tag>
            <el-tag
              v-else-if="scope.row.enabledMark == 2"
              type="warning"
              size="mini"
              disable-transitions
            >Locked</el-tag>
            <el-tag
              v-else-if="scope.row.enabledMark == 3"
              type="warning"
              size="mini"
              disable-transitions
            >Unactivated</el-tag>
            <el-tag v-else type="danger" size="mini" disable-transitions>Deactivated</el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="ACTIONS" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.customerRole == 1">-</div>
            <div v-if="scope.row.customerRole != 1">
              <el-button type="text" style="font-size: 16px;" @click="addOrUpdateHandle(scope.row.id)">
                Edit
              </el-button>
              <el-button
                v-if="scope.row.enabledMark == 1"
                type="text"
                style="font-size: 16px; margin-left: 8px; color: #EF0A0A;"
                @click="()=>{isTip = true, userId = scope.row.id}"
              >
                Deactivate
              </el-button>
              <el-button
                v-if="scope.row.enabledMark == 4"
                type="text"
                style="font-size: 16px; margin-left: 8px;"
                @click="()=>{isTips = true, userId = scope.row.id}"
              >
                Reactivate
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer">
      <span />
    </div>
    <AddUser
      v-if="isAddUser"
      ref="AddUser"
      :value="isAddUser"
      @close="()=>{isAddUser = false}"
      @refresh="refresh"
    />
    <TipsDialog v-if="isTip" :value="isTip" @close="()=>{isTip = false}">
      <template v-slot:title>
        <div>Tips</div>
      </template>
      <template v-slot:body>
        <div class="tips-class">
          <img src="../../../assets/img/manage/icon_tips.png" width="16px" height="16px">
          <span> Are you sure you'd like to deactivate this user? </span>
        </div>
      </template>
      <template v-slot:footer>
        <div class="foot-class">
          <button class="cancel" @click="closeDialog">NO</button>
          <button class="save by-button--primary" @click="updateUserStatus">YES</button>
        </div>
      </template>
    </TipsDialog>
    <TipsDialog v-if="isTips" :value="isTips" @close="()=>{isTips = false}">
      <template v-slot:title>
        <div>Tips</div>
      </template>
      <template v-slot:body>
        <div class="tips-class">
          <img src="../../../assets/img/manage/icon_tips.png" width="16px" height="16px">
          <span> Are you sure you'd like to reactivate this user? </span>
        </div>
      </template>
      <template v-slot:footer>
        <div class="foot-class">
          <button class="cancel" @click="closeDialogs">NO</button>
          <button class="save by-button--primary" @click="updateUserStatus">YES</button>
        </div>
      </template>
    </TipsDialog>
  </div>
</template>

<script>
import {
  GetUserList,
  DisableEnable
} from '../../../api/user.js'
import AddUser from './addUser.vue'
import TipsDialog from '../../../components/Dialog/Dialog.vue'
export default {
  name: 'Users',
  components: {
    // 组件的引用
    AddUser,
    TipsDialog
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      userId: '',
      isAddUser: false,
      isTip: false,
      isTips: false,
      userList: []
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  mounted() {
    // 页面进入时加载内容
  },
  created() {
    // 实例被创建之后执行代码
    this.getUserList()
  },
  methods: {
    formatter(row, column) {
      const role = row[column.property]
      switch (role) {
        case 1:
          return 'Admin'
        case 2:
          return 'User'
      }
    },
    formatterText(row, column) {
      const role = row[column.property]
      switch (role) {
        case 1:
          return 'All company data'
        case 2:
          return 'User data only'
      }
    },
    updateUserStatus() {
      DisableEnable(this.userId).then(res => {
        if (res.code === 200) {
          this.getUserList()
          this.isTip = false
          this.isTips = false
        }
      })
    },
    addOrUpdateHandle(id) {
      this.isAddUser = true
      this.$nextTick(() => {
        this.$refs.AddUser.init(id)
      })
    },
    getUserList() {
      GetUserList().then(res => {
        this.userList = res.data
      })
    },
    refresh(isrRefresh) {
      this.isAddUser = false
      if (isrRefresh) this.getUserList()
    },
    closeDialog() {
      this.isTip = false
    },
    closeDialogs() {
      this.isTips = false
    }
  }
}
</script>
<style scoped lang='scss'>
	.users {
		background: #FFFFFF;
		border-radius: 8px;
		margin-top: 24px;
		padding: 0 24px;

		.users-head {
			display: flex;
			justify-content: space-between;
			height: 64px;
			align-items: center;

			.left {
				font-size: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 600;
				color: #333333;
			}

			.right {
				font-size: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				color: #E95506;
				cursor: pointer;
			}
		}

		table {
			margin-top: 24px;
			width: 100%;
			text-align: left;

			thead {
				tr {
					background: rgba(221, 221, 221, 0.24);
					height: 32px;

					td {
						font-size: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #777777;
					}
				}
			}

			tbody {
				tr {
					height: 40px;

					td {
						border-bottom: 1px solid rgba(221, 221, 221, 0.56);

						.red {
							color: #EF0A0A;
						}
					}

				}
			}
		}

		.footer {
			height: 40px;
			text-align: left;
			line-height: 40px;
		}
	}

	::v-deep .dialog__header {
		text-align: left;
	}

	::v-deep .dialog__body {
		padding: 0;

		.el-form-item {
			margin-bottom: 0;
		}

		.left {
			text-align: left;
		}
	}

	.tips-class {
		display: flex;
		align-items: center;
		margin-top: 16px;
		height: 16px;

		span {
			font-size: 14px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			color: #777777;
			margin-left: 5px;
		}
	}

	.foot-class {
		margin: 24px 0;
		padding-bottom: 24px;
		text-align: right;

		.cancel {
			width: 72px;
			height: 32px;
			background: #FFFFFF;
			border-radius: 4px;
			border: 1px solid #DDDDDD;
			font-size: 14px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			color: #333333;
			margin-right: 16px;
			cursor: pointer;
		}

		.save {
			width: 72px;
			height: 32px;
			border-radius: 4px;
			cursor: pointer;
		}
	}
</style>
